import { useIntercom } from 'hooks/useIntercom';
import { ReactNode } from 'react';

interface IntercomManagerProps {
  children: ReactNode;
}

const IntercomManager = ({ children }: IntercomManagerProps) => {
  useIntercom();
  return <>{children}</>;
};

export default IntercomManager;
